export default {
    namespaced: true,
    state: () => ({
        open: false,
        headline: '',
        body: '',
        buttonText: '',
        props: {},
        dismissible: true
    }),
    mutations: {

        open(state, payload = {}) {
            const {
                headline = '',
                body = '',
                buttonText = [],
                props = {},
                dismissible = true
            } = payload
            state.headline = headline
            state.body = body
            state.buttonText = buttonText
            state.props = props
            state.dismissible = dismissible
            state.open = true
        },

        close(state) {
            state.open = false
            state.headline = ''
            state.body = ''
            state.buttonText = ''
            state.props = {}
            state.dismissible = true
        }
    },
    actions: {
        open({ commit }, data) { commit('open', data) },
        close({ commit }) { commit('close') },
    }
}
